import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
export default class CTA extends Vue {}
